import data from '../data'
import React from 'react';

function Contacts() {
    return (
        <section id="contacts">
          <h2 id="sectionHead">Get In Touch</h2>
          <div class="logoList">
          {
            data.contacts.map(
              i => (
                <img src={i.logo} alt="" srcset=""/>
              )
            )
          }
          </div>
      </section>
    );
  }
  
  export default Contacts;
  